import { WDHResourceCenter } from '../../wdh-resource-center';
var resourceCenter = new WDHResourceCenter('.resource-center');
resourceCenter.run();